// extracted by mini-css-extract-plugin
export default {"root":"ChatContainter_root__w2xdb","header":"ChatContainter_header__uhncJ"};